module.exports = __webpack_public_path__ + "static/media/map_pink.6dc8d7af.svg";